import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import StepperActions from "../../components/StepperActions";
import { useSearchParams } from "../../../../hooks/searchParams";
import { requestConfigData, setConfigData } from "../../services/general/actions";
import { getNormalizersList } from "../../../../services/Normalizers/actions";

import StepThreeConfigurator from "./StepThreeConfigurator";
import { clearStepThreeData } from "./services/stepThree";
import useInitialData from "./hooks/useInitialData";

const Three = () => {
    const dispatch = useDispatch();
    const searchParams = useSearchParams();

    useInitialData(searchParams);

    useEffect(
        () => {
            dispatch(requestConfigData(searchParams));
            dispatch(getNormalizersList());

            return () => {
                dispatch(setConfigData({}));

                clearStepThreeData();
            };
        },
        [ dispatch, searchParams ]
    );

    return (
        <>
            <StepperActions activeStep={2}/>

            <StepThreeConfigurator />
        </>
    );
};

export default Three;
